import React, { useState } from 'react';

const CategoryBadgePicker = ({ categories, selectedIds, onToggle, compact }) => {
  const [search, setSearch] = useState('');
  const q = search.trim().toLowerCase();
  const selectedCategories = categories.filter(c => selectedIds.includes(c.id));
  const suggestions = !q
    ? []
    : categories
      .filter(c => !selectedIds.includes(c.id) && (c.name || '').toLowerCase().includes(q))
      .slice(0, 25);

  const badgeStyle = {
    fontSize: compact ? '0.7rem' : '0.75rem',
    padding: '0.3rem 0.45rem',
    fontWeight: 500,
    maxWidth: compact ? '140px' : '220px'
  };

  const handleAdd = (catId) => {
    if (!selectedIds.includes(catId)) onToggle(catId);
    setSearch('');
  };

  return (
    <div className={compact ? '' : 'border rounded p-2 bg-light'}>
      <div className="d-flex flex-wrap align-items-center mb-2" style={{ gap: '0.35rem', minHeight: compact ? '22px' : '26px' }}>
        {selectedCategories.length === 0 ? (
          <span className="text-muted small mb-0">Категорії не обрані</span>
        ) : (
          selectedCategories.map(cat => (
            <span
              key={cat.id}
              className="badge badge-dark d-inline-flex align-items-center"
              style={badgeStyle}
              title={cat.name}
            >
              <span className="text-truncate">{cat.name}</span>
              <button
                type="button"
                className="btn p-0 ml-1 border-0 bg-transparent flex-shrink-0"
                onClick={() => onToggle(cat.id)}
                aria-label={`Прибрати ${cat.name}`}
                style={{ fontSize: '0.85rem', color: 'inherit', lineHeight: 1, cursor: 'pointer', opacity: 0.85 }}
              >
                <i className="bi bi-x" style={{ fontWeight: 'bold' }} />
              </button>
            </span>
          ))
        )}
      </div>
      <input
        type="text"
        className="form-control form-control-sm"
        placeholder="Пошук і додавання категорій..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      {q ? (
        <div
          className="border rounded bg-white mt-1"
          style={{ maxHeight: compact ? '140px' : '180px', overflowY: 'auto' }}
        >
          {suggestions.length === 0 ? (
            <p className="text-muted small mb-0 px-2 py-2">Нічого не знайдено</p>
          ) : (
            suggestions.map(cat => (
              <button
                type="button"
                key={cat.id}
                className="btn btn-link btn-sm btn-block text-left text-dark py-1 px-2"
                style={{
                  fontSize: '0.75rem',
                  textDecoration: 'none',
                  borderRadius: 0,
                  borderBottom: '1px solid #eee',
                  ...(!cat.parentId ? { borderLeft: '3px solid #007bff' } : {})
                }}
                onClick={() => handleAdd(cat.id)}
              >
                {cat.name}
              </button>
            ))
          )}
        </div>
      ) : (
        <p className="text-muted small mb-0 mt-1">Введіть назву — клікніть, щоб додати бейдж</p>
      )}
    </div>
  );
};

export default CategoryBadgePicker;
